//erplint-ignore
import React, {Component, Suspense} from 'react';
import Axios from '../helpers/api_client';
import {Row, Col} from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import Path13 from '../images/Path 13.svg';
import PtwWhiteTransparent from '../images/PTW-Logo-3lines.svg';
import Pathsvg from '../images/Path14-svg.png';
import './login.css';
import TextPopup from './textPopup';
import {fetchProfileInfo} from '../apis/profile/profile.api';
import {until} from '../helpers/helpers';
import Eye from '../images/svg/password-eye.svg';
import eye_hide_pwd from '../images/svg/eye_hide_pwd.svg';
import {Link} from 'react-router-dom';
import {withTranslation} from 'react-i18next';

class LegacyComponentClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_name: '',
      password: '',
      blocking: false,
      messagePopup: false,
      message: '',
      currentPwdMode: true,
      passwordreadonly: false,
    };
  }

  strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})',
  );

  componentDidMount() {
    var x = document.getElementById('password');
    var style = window.getComputedStyle(x);
    if (style.webkitTextSecurity) {
      //do nothing
    } else {
      x.setAttribute('type', 'password');
    }
  }

  changeHandler = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };

  onClosePopup = () => {
    this.setState({
      messagePopup: !this.state.messagePopup,
    });
  };
  submitHandler = (e) => {
    e.preventDefault();
    this.setState({blocking: true});
    Axios.post(`${process.env.REACT_APP_API_GATEWAY_URL}base/login/`, {
      userName: this.state.user_name,
      password: this.state.password,
    })
      .then((res) => {
        const userDetails = res.data.result[0];
        const access_token = userDetails.access_token;
        const currentUserId = userDetails.id;
        const firstName = userDetails.firstName;
        const lastName = userDetails.lastName || '';
        const name = `${firstName} ${lastName}`;
        const isManager = userDetails.isSubordinates;
        localStorage.setItem('awl_token', access_token);
        localStorage.setItem('currentUserId', currentUserId);
        localStorage.setItem('empName', name);
        localStorage.setItem('isManager', isManager);
        localStorage.setItem('country', userDetails.country);
        localStorage.setItem('userDetails', JSON.stringify(userDetails));
        localStorage.setItem(
          'showWalkThrough',
          (!!userDetails.loginCount && userDetails.loginCount <= 1) ||
            userDetails.isLoginFirstTime,
        );
        this.saveProfileDetails(currentUserId, isManager);
        this.setState({blocking: false});
      })

      .catch((error) => {
        let errMsg = ((error.response || error).data || error).message;
        this.setState({
          messagePopup: !this.state.messagePopup,
          message: errMsg || 'The username or password is incorrect',
          blocking: false,
        });
      });
  };

  saveProfileDetails = async (userId, isManager) => {
    const [err, data] = await until(fetchProfileInfo(userId));
    if (data.count != 0) {
      localStorage.setItem('profileSettings', JSON.stringify(data.result[0]));
    }
    if (err) {
      return;
    }
    // window.location = !isManager ? 'ess/leaves' : '/user-management/users';
    window.location = '/payroll/salary-information';
  };

  setcurrentPwdMode = () => {
    this.setState(
      {
        currentPwdMode: !this.state.currentPwdMode,
      },
      () => {
        var x = document.getElementById('password');
        var style = window.getComputedStyle(x);
        if (style.webkitTextSecurity) {
          //do nothing
        } else if (!this.state.currentPwdMode) {
          x.setAttribute('type', 'text');
        } else {
          x.setAttribute('type', 'password');
        }
      },
    );
  };

  render() {
    // Localization
    const {t} = this.props;
    const {currentPwdMode} = this.state;
    return (
      <>
        <div className="login-section">
          <Row className="my-0">
            <Col sm="6" md="6" lg="6" className="login-left mx-0 ">
              <div className="mask-img-part">
                <div className="bi-content">
                  <Image
                    src={PtwWhiteTransparent}
                    alt=""
                    className="login-logo-sizes"
                  />
                </div>
              </div>
            </Col>
            <Col sm="6" md="6" lg="6" className="login-part position-relative">
              <>
                <Image src={Path13} className="path1" />
                <Image src={Pathsvg} className="path2" />
                <form
                  onSubmit={this.submitHandler}
                  className="login-form"
                  autoComplete="new-password"
                >
                  <div className="login-title mb-3">{t('Login')}</div>
                  <div className="form-group mb-4">
                    <label className="user-icon">{t('Username')}</label>
                    <input
                      type="text"
                      required
                      className="awl-form-control"
                      name="user_name"
                      onChange={this.changeHandler}
                      autoComplete="off"
                      tabIndex="0"
                      readOnly
                      onFocus={(event) =>
                        event.target.removeAttribute('readonly')
                      }
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label className="password-icon">
                      {' '}
                      <span style={{marginTop: '-20px'}}>{t('Password')}</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type="text"
                        required
                        className={
                          currentPwdMode
                            ? 'awl-form-control text-security'
                            : 'awl-form-control'
                        }
                        name="password"
                        id="password"
                        onChange={this.changeHandler}
                        autoComplete="off"
                        tabIndex="0"
                      />
                      <Image
                        style={{cursor: 'pointer'}}
                        className={'eye-icon'}
                        src={currentPwdMode ? eye_hide_pwd : Eye}
                        onClick={this.setcurrentPwdMode}
                      />
                    </div>
                  </div>
                  <div className="row mb-3" style={{userSelect: 'text'}}>
                    <div className="col-md-7">
                      <div className="form-group">
                        <div className="custom-control pl-0 custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck1"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck1"
                          >
                            {' '}
                            <span className="rmbr">
                              {t('Remember Me')}
                            </span>{' '}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <a className="forgot-pass" href="/forgot-password">
                        {t('Forgot Your Password ')}?
                      </a>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn create-type-btn btn-block"
                  >
                    {t('Sign In')}
                  </button>
                  <div className="mt-4 d-flex justify-content-end">
                    <div className="d-flex">
                      <div className="account pr-2">
                        {t('To create a company account')}{' '}
                      </div>
                      <Link to="/login-signup">
                        <div className="forgot-pass signup pr-1 pl-2">
                          &nbsp; {t('Click')}{' '}
                        </div>
                      </Link>
                      <div className="account"> {t('here')}</div>
                    </div>
                  </div>
                </form>
              </>
            </Col>
          </Row>
        </div>

        {this.state.messagePopup && (
          <TextPopup
            title={this.state.message}
            onClosePopup={this.onClosePopup}
          />
        )}
      </>
    );
  }
}

// Localization
const MyComponent = withTranslation()(LegacyComponentClass);
export default function Login() {
  return (
    <Suspense fallback="loading">
      <MyComponent />
    </Suspense>
  );
}
